<div class="row pad25 mobHeight bgModal" style="margin: 0px;">
    <div class="col-md-12 col-12 col-sm-12" style="padding: 15px;">
        <div class="col-md-8 col-5 col-sm-8 pad0 inLneBlk" style="vertical-align: top;">
            <h4>{{ isEdit ? 'Update' : 'Add' }} Project Type</h4>
        </div>
        <div class="col-md-4 col-7 col-sm-4 txtRight pad0 inLneBlk fn13">
            <span class="btn btn-darkGreen brdrRadius3" style="margin: 0px 10px 0px 10px; padding: 5px 8px; font-size: 14px; line-height: 18px;" (click)="save()">
                <i class="fa fa-check" style="margin-right: 5px;"></i>
                {{ isEdit ? 'Update' : 'Save' }}
            </span>
            <span style="display: inline;">
                <span class="closeMdl ng-scope" (click)="closeModel('')" style="padding: 5px 10px !important;">
                    <i class="zmdi zmdi-close"></i>
                </span>
            </span>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6 col-md-6 pad0">
                <!-- Name --> 
                <div class="col-md-12 col-sm-12 col-12 pdng mrgnTp10" style="text-align: left;">
                    <div class="label-new">Name</div>
                    <input type="text" [(ngModel)]="projectType.name" (keyup)="updateCode()" class="form-control fn13 formCtlFltr" maxlength="100" style="color: rgb(0, 0, 0); background-color: white !important;">
                </div>
                
                <!-- Code -->
                <div class="col-md-12 col-sm-12 col-12 pdng mrgnTp10" style="text-align: left;">
                    <div class="label-new">Code</div>
                    <input type="text" [(ngModel)]="projectType.code" (keyup)="toggleCodeChange()" class="form-control fn13 formCtlFltr" maxlength="50" style="color: rgb(0, 0, 0); background-color: white !important;">
                </div>

                <!-- Stages - MobView -->
                <div class="col-md-12 col-sm-12 col-12 pdng mrgnTp10 mobView" style="text-align: left;">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
                        <div class="label-new">Stages</div>
                    </div>
                    <div style="display: flex; gap: 10px; margin-bottom: 10px;">
                        <input id="inputAddStage" type="text" [(ngModel)]="newStage"  class="form-control fn13 formCtlFltr" maxlength="50" style="color: rgb(0, 0, 0); background-color: white !important;">
                        <span title="Add Stage" (click)="addStage()" class="btn-darkGreen-alt height30" style="padding: 3px 10px;">
                            <i class="zmdi zmdi-check"></i>
                        </span>
                        <span (click)="clearAddStage()" class="btn-darkGreen-alt height30" style="padding: 4px 10px;">
                            <i class="zmdi zmdi-close"></i>
                        </span>
                    </div>
                    <div *ngIf="projectType.stages.length > 0" class="col-md-12 col-sm-12 col-xs-12 pad0" style="max-height: 300px; overflow-y: auto; font-size: 13px; background-color: #fff;">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th style="width: 15%; padding: 7px;">No.</th>
                                    <th style="width: 55%; padding: 7px;">Stage</th>
                                    <th style="width: 30%; padding: 7px;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let stage of projectType.stages; let i = index;">
                                    <td style="padding: 7px; text-align: right;">{{ i+1 }}</td>
                                    <td style="padding: 7px;">
                                        <span *ngIf="isEditStage && editStageIndex == i">
                                            <input type="text" [(ngModel)]="stage.SNm" class="form-control fn13 formCtlFltr" style="border: 0px;">
                                        </span>
                                        <span *ngIf="!isEditStage || editStageIndex != i">
                                            {{ stage.SNm }}
                                        </span>
                                    </td>
                                    <td style="padding: 7px; text-align: center;">
                                        <div *ngIf="isEditStage && editStageIndex == i">
                                            <span title="Edit Stage" (click)="toggleEditStage(i, false)" class="btn-darkGreen-alt height30" style="padding: 3px 10px;">
                                                <i class="zmdi zmdi-check"></i>
                                            </span>
                                        </div>
                                        <div *ngIf="!isEditStage || editStageIndex != i">
                                            <span title="Edit Stage" (click)="toggleEditStage(i, true)" class="lableBtnGray height30" style="font-size: 12px; cursor: pointer; padding: 6px 10px; margin-right: 10px;">
                                                <i class="fa fa-pencil"></i>
                                            </span>
                                            <span title="Remove Stage" (click)="removeStage(i)" class="lableBtnGray height30" style="font-size: 12px; cursor: pointer; padding: 6px 10px;">
                                                <i class="fa fa-trash"></i>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Materials -->
                <div class="col-md-12 col-sm-12 col-12 pdng mrgnTp10" style="text-align: left;">
                    <span *ngIf="projectType.BOM.length == 0" (click)="openItemSelect(i, false)" class="btn-darkGreen-alt height30" style="padding: 3px 10px;">
                        <i class="zmdi zmdi-plus" style="margin-right: 5px;"></i>
                        <span style="font-size: 13px;">Add Materials</span>
                    </span>
                    <div *ngIf="projectType.BOM.length > 0" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
                        <div class="label-new">Materials</div>
                        <span title="Add Materials" (click)="openItemSelect()" class="lableBtGreenMain height30" style="font-size: 15px; cursor: pointer; padding: 2px 10px;">
                            <i class="zmdi zmdi-plus"></i>
                        </span>
                    </div>
                    <div *ngIf="projectType.BOM.length > 0" class="col-md-12 col-sm-12 col-xs-12 pad0" style="max-height: 240px; overflow-y: auto; font-size: 13px; background-color: #fff; border-radius: 3px;">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th style="width: 10%; padding: 7px;">No.</th>
                                    <th style="width: 50%; padding: 7px;">Material</th>
                                    <th style="width: 30%; padding: 7px;">Qty</th>
                                    <th style="width: 10%; padding: 7px;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let material of projectType.BOM; let i = index;">
                                    <td style="padding: 7px; text-align: right;">{{ i+1 }}</td>
                                    <td style="padding: 7px;">
                                        {{material.productName}}
                                    </td>
                                    <td style="padding: 7px; text-align: center;">
                                        <input type="text" id="txtItem" class="form-control fn13 formCtlFltr" tabindex="1"  [(ngModel)]="material.ReqdQty"  placeholder="Qty" (keyup)="prcisionCheck(material);" style="height: 25px; width: 80px; text-align: right;" maxlength="50" />
                                        <span style="margin-left: 5px; font-size: 13px;">{{ material.Unit }}</span>
                                    </td>
                                    <td style="padding: 7px; text-align: center;">
                                        <span title="Remove Material" (click)="removeMaterial(i)" class="lableBtnGray height30" style="font-size: 12px; cursor: pointer; padding: 6px 10px;">
                                            <i class="fa fa-trash"></i>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Stages - WebView -->
            <div class="col-6 pad0 webView">
                <!-- Stages -->
                <div class="col-md-12 col-sm-12 col-12 pdng" style="text-align: left; margin-top: 5px;">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
                        <div class="label-new">Stages</div>
                    </div>
                    <div style="display: flex; gap: 10px; margin-bottom: 10px;">
                        <input id="inputAddStageWeb" type="text" [(ngModel)]="newStage"  class="form-control fn13 formCtlFltr" maxlength="50" style="color: rgb(0, 0, 0); background-color: white !important;">
                        <span title="Add Stage" (click)="addStage()" class="btn-darkGreen-alt height30" style="padding: 3px 10px;">
                            <i class="zmdi zmdi-check"></i>
                        </span>
                        <span (click)="clearAddStage()" class="btn-darkGreen-alt height30" style="padding: 4px 10px;">
                            <i class="zmdi zmdi-close"></i>
                        </span>
                    </div>
                    <div *ngIf="projectType.stages.length > 0" class="col-md-12 col-sm-12 col-xs-12 pad0" style="max-height: 335px; overflow-y: auto; font-size: 13px; background-color: #fff;">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th style="width: 10%; padding: 7px;">No.</th>
                                    <th style="width: 70%; padding: 7px;">Stage</th>
                                    <th style="width: 20%; padding: 7px;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let stage of projectType.stages; let i = index;">
                                    <td style="padding: 7px; text-align: right;">{{ i+1 }}</td>
                                    <td style="padding: 7px;">
                                        <span *ngIf="isEditStage && editStageIndex == i">
                                            <input type="text" [(ngModel)]="stage.SNm" class="form-control fn13 formCtlFltr" style="border: 0px;">
                                        </span>
                                        <span *ngIf="!isEditStage || editStageIndex != i">
                                            {{ stage.SNm }}
                                        </span>
                                    </td>
                                    <td style="padding: 7px; text-align: center;">
                                        <div *ngIf="isEditStage && editStageIndex == i">
                                            <span title="Edit Stage" (click)="toggleEditStage(i, false)" class="btn-darkGreen-alt height30" style="padding: 3px 10px;">
                                                <i class="zmdi zmdi-check"></i>
                                            </span>
                                        </div>
                                        <div *ngIf="!isEditStage || editStageIndex != i">
                                            <span title="Edit Stage" (click)="toggleEditStage(i, true)" class="lableBtnGray height30" style="font-size: 12px; cursor: pointer; padding: 6px 10px; margin-right: 10px;">
                                                <i class="fa fa-pencil"></i>
                                            </span>
                                            <span title="Remove Stage" (click)="removeStage(i)" class="lableBtnGray height30" style="font-size: 12px; cursor: pointer; padding: 6px 10px;">
                                                <i class="fa fa-trash"></i>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- Save -->
            <div class="col-md-12 col-sm-12 col-12 pdng mrgnTp10" style="text-align: left;">
                <span class="btn btn-darkGreen brdrRadius3" style="padding: 5px 8px; font-size: 14px; line-height: 18px;" (click)="save()">
                    <i class="fa fa-check" style="margin-right: 5px;"></i>
                    {{ isEdit ? 'Update' : 'Save' }}
                </span>
            </div>
        </div>
    </div>
</div>
<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">
</ngx-spinner>